import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'

import { withRouter } from 'react-router-dom'

import { EventsList } from '../EventsList/EventsList'
import { eventCommunicator } from '../../../communicators/eventCommunicator'
import { TopSectionTitle } from '../TopSectionTitle/TopSectionTitle'
import { DetailsLink } from '../DetailsLink/DetailsLink'
import { SectionBlock } from '../SectionBlock/SectionBlock'
import NoEvents from '../NoEvents/NoEvents'
import { Pagination } from '../Pagination/Pagination'

class WebPageEvents extends Component {
    constructor(props) {
        super(props)

        this.state = {
            events: [],
            pagesList: [],
            lastPage: 1
        }

        this.updateEvents = this.updateEvents.bind(this)
    }

    getPages(n) {
        const array = []
        for (let i = 1; i <= n; i++) {
            array.push(i)
        }
        return array
    }

    async updateEvents(currentPage) {
        this.loadEvents(currentPage)
    }

    async loadEvents(page) {
        try {
            const { departments } = this.props

            const response = await eventCommunicator.fetchEventsByDepartment(
                page,
                departments[0].id
            )

            this.setState({
                events: response.events,
                lastPage: response.pagination.totalPages,
                pagesList: this.getPages(response.pagination.totalPages)
            })
        } catch (error) {
            console.error(error)
        }
    }

    componentDidMount() {
        this.loadEvents()
    }

    onShowAllEvents = () => {
        const { history } = this.props

        history.push('/dogadjaji')
    }

    render() {
        const { events, lastPage, pagesList } = this.state
        const { t } = this.props

        return (
            <>
                <SectionBlock withContainer>
                    <TopSectionTitle title={t('allEvents.title')} underlined dark centered />
                    {events.length > 0 ? <EventsList eventsList={events} /> : <NoEvents dark />}
                    {pagesList.length > 1 && (
                        <Pagination
                            lastPage={lastPage}
                            pagesList={pagesList}
                            updateContent={this.updateEvents}
                            light
                        />
                    )}
                    <DetailsLink
                        text={t('association.eventsSection.details')}
                        onDetailsClick={this.onShowAllEvents}
                    />
                </SectionBlock>
            </>
        )
    }
}

export default withTranslation()(withRouter(WebPageEvents))
